import { SCat, SDog, SHamster, SParrot } from './PetHeroImage.styled'
import React from 'react'

export const PetHeroImage = () => {
  return (
    <>
      <SDog src="/images/pet/dogAvatar.png" />
      <SHamster src="/images/pet/hamsterAvatar.png" />
      <SCat src="/images/pet/catAvatar.png" />
      <SParrot src="/images/pet/parrotAvatar.png" />
    </>
  )
}
